import React from "react";
import { Scale, Mic, Moon } from "lucide-react";

const ATELIERS = [
  {
    icon: Scale,
    title: "Corps & Droit",
    subtitle: "Connaître ses droits, se défendre",
    text:
      "Accompagnement juridique bénévole, compréhension du cadre légal, préparation de la défense.",
    key: "corps-droit",
  },
  {
    icon: Mic,
    title: "Corps & Voix",
    subtitle: "Libérer la parole",
    text:
      "Expression artistique — peinture, écriture, arts plastiques, théâtre — pour redonner voix au corps silencié.",
    key: "corps-voix",
  },
  {
    icon: Moon,
    title: "Corps & Cosmos",
    subtitle: "Se relier au sacré",
    text:
      "Méditation, souffle, reconnexion au corps comme lieu sacré et source de paix intérieure.",
    key: "corps-cosmos",
  },
];

const GROUP_IMG =
  "https://customer-assets.emergentagent.com/job_86572a60-f169-4826-bdbe-647ca27ec590/artifacts/1ihak0st_IMG-20260420-WA0008.jpg";

export default function Ateliers() {
  return (
    <section
      id="ateliers"
      data-testid="ateliers-section"
      className="bg-[#FAF7F2] py-24 lg:py-36"
    >
      <div className="max-w-[1400px] mx-auto px-6 grid lg:grid-cols-12 gap-16 items-start">
        <div className="lg:col-span-5">
          <p className="sdm-divider">Trois dimensions</p>
          <h2 className="font-serif-display text-4xl lg:text-6xl text-[#4A192C] mt-8 leading-tight">
            Les Ateliers de Souveraineté
          </h2>
          <p className="mt-6 text-[#2C1E23]/85 text-lg leading-relaxed">
            Reprendre sa puissance ne se décrète pas : elle se pratique.
            Trois ateliers, trois dimensions — pour reconstruire la femme
            dans son entièreté.
          </p>

          <div className="mt-10 relative aspect-[4/5] overflow-hidden max-w-md">
            <img
              src={GROUP_IMG}
              alt="Cercle de parole au Sanctuaire des Mères"
              className="w-full h-full object-cover grayscale-[15%] hover:grayscale-0 transition-all duration-700"
              loading="lazy"
            />
            <div className="absolute top-4 left-4 bg-[#C5A059] text-[#4A192C] px-3 py-1 text-[0.65rem] tracking-[0.2em] uppercase font-semibold">
              Cercle de parole — Paris
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 flex flex-col divide-y divide-[#4A192C]/20">
          {ATELIERS.map((a, i) => (
            <div
              key={a.key}
              data-testid={`atelier-${a.key}`}
              className="py-10 first:pt-0 group grid grid-cols-[auto_1fr_auto] gap-6 items-start"
            >
              <div className="w-14 h-14 border border-[#4A192C] flex items-center justify-center group-hover:bg-[#4A192C] transition-colors duration-500">
                <a.icon className="w-6 h-6 text-[#4A192C] group-hover:text-[#C5A059] transition-colors duration-500" />
              </div>
              <div>
                <div className="text-[0.68rem] tracking-[0.22em] uppercase text-[#C5A059] mb-2 font-medium">
                  {a.subtitle}
                </div>
                <h3 className="font-serif-display text-3xl text-[#4A192C]">
                  {a.title}
                </h3>
                <p className="mt-4 text-[#2C1E23]/80 leading-relaxed max-w-xl">
                  {a.text}
                </p>
              </div>
              <div className="font-serif-display text-5xl text-[#4A192C]/20">
                0{i + 1}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
